/**
 * AboutDialog — version / build info shown from Help › About EIS.
 */
import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from '@mui/material';

const VERSION = process.env.REACT_APP_VERSION || 'dev';
const BUILD = process.env.REACT_APP_BUILD || 'local';

const AboutDialog = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>About EIS</DialogTitle>
    <DialogContent>
      <Box sx={{ textAlign: 'center', py: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
          EIS
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
          Engineering Intelligence System
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Version {VERSION}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Build {BUILD}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 3 }}>
          <Link href="/changelog">Release notes</Link>
          {' · '}
          <Link href="/help">Help center</Link>
          {' · '}
          <Link href="/legal">Legal</Link>
        </Typography>
      </Box>
    </DialogContent>
  </Dialog>
);

export default AboutDialog;
